<template>
  <div>
    <v-data-table
      dense
      :headers="assets_headers"
      :items="employeeAssets"
      :items-per-page="5"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, -1]
      }"
    >
      <template v-slot:[`item.Warranty_End_Date`]="{ item }">
        {{ item.Warranty_End_Date | dateFilter }}
      </template>
      <template v-slot:[`item.Lease_Agreement`]="{ item }">
        <v-checkbox
          v-model="item.Lease_Agreement"
          class="checkbox-center"
          :ripple="false"
          readonly
        ></v-checkbox>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <v-btn
          icon
          small
          @click.prevent="editCurrentAsset(item)"
          color="primary"
        >
          <v-icon>mdi-pencil-circle</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <AssetDetails
      v-model="show"
      :asset="selecetedAsset"
      :assetCategories="assetCategories"
      :assetSubcategories="assetSubCategories"
      :notFromAssetsModule="true"
    />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'

export default {
  name: 'EmployeeAssets',
  components: {
    AssetDetails: () => import('@/components/assets/AssetDetails.vue')
  },
  props: {
    employeeID: {
      required: true
    },
    rolesOfUser: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      employeeAssets: [],
      assetDialog: false,
      selecetedAsset: {},
      assetCategories: [],
      assetSubCategories: []
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    Financier_AssetsManager () {
      let res = false
      for (let i = 0; i < this.rolesOfUser.length; i++) {
        if (['financier', 'assets_manager'].indexOf(this.rolesOfUser[i].RoleName) > -1) {
          res = true
          break
        }
      }
      return res
    },
    assets_headers () {
      return [
        {
          text: 'Category',
          value: 'Category_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Subcategory',
          value: 'Subcategory_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Inventory #',
          value: 'Invertory_Number',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Brand',
          value: 'Brand',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Model',
          value: 'Model',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Warranty End Date',
          value: 'Warranty_End_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Employee',
          value: 'Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Status',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Lease Agreement',
          value: 'Lease_Agreement',
          divider: true,
          width: '5%',
          class: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: '',
          value: 'Actions',
          width: '5%',
          divider: true,
          class: 'px-2 text-no-wrap',
          show: this.Financier_AssetsManager
        }
      ].filter(item => item.show)
    },
    show: {
      get () {
        return this.assetDialog
      },
      set (val) {
        if (!val) {
          this.getAssets()
        }
        this.assetDialog = val
      }
    }
  },
  mounted () {
    this.getAssetCategories()
    this.getAssets()
  },
  methods: {
    getAssets () {
      this.axios.get(`/api/${this.employeeID}/assets`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.employeeAssets = result.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    editCurrentAsset (item) {
      this.axios.get(`/api/assetdetails/${item.Asset_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selecetedAsset = res.data[0]
        this.show = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getAssetCategories () {
      this.axios.get('/api/asset_categories', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.assetCategories.push({ Asset_Category_ID: 0, Category_Name: 'All' })
        for (let i = 0; i < res.data[0].length; i++) {
          this.assetCategories.push(res.data[0][i])
        }
        for (let i = 0; i < res.data[1].length; i++) {
          this.assetSubCategories.push({
            ...res.data[1][i],
            Show: true
          })
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  },
  filters: {
    dateFilter (val) {
      return val ? formatLocalDate(val) : ''
    }
  }
}
</script>
